require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-501-ios-app-development-with-swift.json") })
        }
      }, "path---courses-code-501-ios-app-development-with-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-501-ios-app-development-with-swift!./.cache/json/courses-code-501-ios-app-development-with-swift.json
// module id = 1169
// module chunks = 231608221292675